<template>
  <div class="crop-selection a-rows general-end">

    <div class="a-row">

      <div class="a-column">
        <app-sel
          v-model="form.baseCropId"
          filterable
          :label="$ml.get(`Crop Name`)"
          :items="filteredCrops"
          key-name="id"
          label-name="name"
          @input="onCropSelect"
        >
          <template v-slot="{ items }">
            <app-sel-opt v-for="item in items" :value="item" :key="item.key">
              <template>{{ $ml.get(item.name) }}</template>
              <!-- ({{ (item.type == 'soil-grown') ? 'soil grown' : 'hydroponic'  }}) -->
            </app-sel-opt>
          </template>
        </app-sel>
      </div>

      <div class="a-column">
        <app-sel
          v-model="form.cropVarietyId"
          :label="$ml.get(`Type`)"
          :items="varieties"
          key-name="id"
          label-name="name"
          :disabled="!form.baseCropId"
          @input="onVarietySelect"
        >
          <template v-slot="{ items }">
            <app-sel-opt v-for="item in items" :value="item" :key="item.key">
              {{ $ml.get(item.name) }}
            </app-sel-opt>
          </template>
        </app-sel>
      </div>

      <div class="a-column">
        <app-sel
          v-model="form.cropGrowingMethodId"
          :label="$ml.get(`Growing method`)"
          :items="methods"
          key-name="id"
          label-name="name"
          :disabled="!form.cropVarietyId"
          @input="onMethodSelect"
        >
          <template v-slot="{ items }">
            <app-sel-opt v-for="item in items" :value="item" :key="item.key">
              {{ $ml.get(item.name) }}
            </app-sel-opt>
          </template>
        </app-sel>
      </div>

    </div>

    <div class="a-row">

      <div class="a-column" v-show="program.type == 'soil-based'">
        <app-sel
          v-model="form.cropYieldGoalId"
          :label="$ml.get(`Yield Goal, `) + $store.getters['unit/getLabel']('t/ha')"
          :items="goals"
          key-name="id"
          label-name="goal"
          :disabled="!form.cropGrowingMethodId"
        >
          <template v-slot="{ items }">
            <app-sel-opt v-for="item in items" :value="item" :key="item.key">
                {{ item.goal }}
            </app-sel-opt>
          </template>
        </app-sel>
      </div>

    </div>

  </div>
</template>

<script>
import { CropAPI } from '@/api';
import { mapGetters } from 'vuex'

export default {
  props: {

  },
  data() {
    return {
      crops: [],
      varieties: [],
      methods: [],
      goals: [],
    }
  },
  methods: {

    primaryLoad() {
      if(this.$store.getters['program/data'].type == 'soil-based') {
        this.crops = this.$store.getters['user-crops/data'].filter(x => x.type == 'soil-grown');
      }else if(this.$store.getters['program/data'].type == 'hydroponic'){
        this.crops = this.$store.getters['user-crops/data'].filter(x => x.type == 'nutrient solution');
        // this.crops = this.$store.getters['user-crops/data'].filter(x => x.type == 'soil-grown');
      }

      if(this.form.baseCropId) {
        this.getVarieties();
      }
      if(this.form.cropVarietyId) {
        this.getMethods();
      }
      if(this.form.cropGrowingMethodId) {
        this.getYieldGoals();
      }
    },

    onCropSelect() {
      this.varieties = [];
      this.methods = [];
      this.goals = [];

      this.form.cropVarietyId = 0;
      this.form.cropGrowingMethodId = 0;
      this.form.cropYieldGoalId = 0;

      this.getVarieties();
    },
    onVarietySelect() {
      this.methods = [];
      this.goals = [];

      this.form.cropGrowingMethodId = 0;
      this.form.cropYieldGoalId = 0;

      this.getMethods();
    },
    onMethodSelect() {
      this.goals = [];

      this.form.cropYieldGoalId = 0;

      this.getYieldGoals();
    },

    getVarieties(id) {
      return CropAPI.getCropVarieties(this.form.baseCropId).then(res => {
        this.varieties = res.data.data;
      });
    },
    getMethods(id) {
      return CropAPI.getCropGrowingMethods(this.form.cropVarietyId).then(res => {
        this.methods = res.data.data;
      });
    },
    getYieldGoals(id) {
      return CropAPI.getYieldGoals(this.form.cropGrowingMethodId).then(res => {
        this.goals = res.data.data;
        if(this.$store.getters['user/data'].units.toLowerCase() == 'us') {
          this.goals.forEach(e => e.goal = this.$store.getters['unit/convert']('t/ha', e.goal))
        }
        if(this.$store.getters['program/data'].type == 'hydroponic') {
          this.form.cropYieldGoalId = this.goals[0].id;
          // console.log(this.goals[0].id);
          // console.log(this.program.cropYieldGoalId);
        }
      });
    }
  },

  computed: {
    ...mapGetters({
      program: 'program/data',
      userCrops : 'user-crops/data',
      form: 'program/general-settings/form',
    }),

    filteredCrops() {
      return this.crops.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0)
    }
  },

  watch: {
    'program': function (to) {
      // console.log(to.id, this.program.id);
      this.primaryLoad();
    }
  },

  created() {
    this.primaryLoad();

  },
}
</script>

<style lang="scss" scoped>

.crop-selection {
  width: 100%;
  // @media (max-width: 768px) {
  //    &.a-rows{
  //     .a-row {
  //       .a-column {
  //         flex-basis: 100%;
  //         margin-right: 0;
  //         margin-left: 0;
  //       }
  //     }
  //   }
  // }
}
.general-end{
  padding-bottom: 70px;
}
@media (max-width: 768px){
  .general-end{
    padding-bottom: 80px;
  }

}
</style>
